import { z } from 'zod'

import { ACTIVITY_TYPES } from './-care-log-edit-shared'
import type { CareLogActivityType } from '@/lib/api/care-logs-api'

export interface CareLogNewSearch {
    /** Chọn sẵn hoạt động (deep link từ thông báo nhắc việc chăm sóc). */
    activity?: CareLogActivityType
    /** Vùng trồng của mã QR vừa quét — form điền sẵn bước Địa điểm. */
    area_id?: string
}

const uuidSchema = z.string().uuid()

/**
 * `validateSearch` của trang tạo nhật ký. URL sửa tay được nên mọi tham số là
 * dữ liệu không tin cậy: hoạt động lạ hay mã vùng không phải UUID đều bị bỏ,
 * không để rác lọt xuống API.
 */
export function validateCareLogNewSearch(
    search: Record<string, unknown>,
): CareLogNewSearch {
    const out: CareLogNewSearch = {}
    const { activity, area_id: areaId } = search
    if (
        typeof activity === 'string' &&
        (ACTIVITY_TYPES as string[]).includes(activity)
    ) {
        out.activity = activity as CareLogActivityType
    }
    if (uuidSchema.safeParse(areaId).success) {
        out.area_id = areaId as string
    }
    return out
}
